import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { DriverPersonalDetailTabComponent } from './driver-personal-detail-tab/driver-personal-detail-tab.component';
import { DriverLicenseDetailTabComponent } from './driver-license-detail-tab/driver-license-detail-tab.component';
import { DriverVehicleDetailTabComponent } from './driver-vehicle-detail-tab/driver-vehicle-detail-tab.component';

@Component({
  selector: 't-llevo-driver-detail-tab',
  standalone: true,
  imports: [
    MatTabsModule,
    DriverPersonalDetailTabComponent,
    DriverLicenseDetailTabComponent,
    DriverVehicleDetailTabComponent,
  ],
  template: `
    <mat-tab-group animationDuration="200">
      <mat-tab label="Personal" bodyClass="my-1 mx-3">
        <t-llevo-driver-personal-detail-tab></t-llevo-driver-personal-detail-tab>
      </mat-tab>
      <mat-tab label="Licencia" bodyClass="my-1 mx-3">
        <t-llevo-driver-license-detail-tab></t-llevo-driver-license-detail-tab>
      </mat-tab>
      <mat-tab label="Vehiculo" bodyClass="my-1 mx-3">
        <t-llevo-driver-vehicle-detail-tab></t-llevo-driver-vehicle-detail-tab>
      </mat-tab>
    </mat-tab-group>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverDetailTabComponent {}
